import React from 'react';

import styles from './styles/about-06.module.css';

import {ReactComponent as HistoryImg} from '../../assets/about06/history.svg';

export default function About06() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <p>
                    Make it definite,<br />
                    makes us infinite
                </p>
                <div>
                    <HistoryImg />
                </div>
            </div>
        </div>
    );
}
